import React, { Component } from 'react'
import "./VariationsSelector.css";

export default class VariationsSelector extends Component {

  render() {
    const {getSelectedVariants, selectedVariants, ProductData} = this.props
    return (
        <div>
            {ProductData.productWithVariations === "SI"?
                <VariationsSelector_variations_boxes selectedVariants={selectedVariants} getSelectedVariants={getSelectedVariants} unit={0} selectedPackId={"0"} ProductData={ProductData} id={"0"} />  
            :null}
        </div>
    )
  }
}


export class VariationsSelector_variations_boxes extends Component {
  render() {
    const {getSelectedVariants, selectedVariants, ProductData, unit, selectedPackId, id} = this.props

    return (
      <div className='VariationsSelector_variations_boxes'>
        {selectedPackId===id?
        ProductData.productOptions.map((variantData, i) =>
        <div className='VariationsSelector_variations_boxes_option_box'>
            <div className='VariationsSelector_variations_box_label' id={id}>{variantData.name}: <span style={{color:"grey", fontWeight:"lighter", fontSize:"17px"}}>{selectedVariants.length > 0?selectedVariants[unit]["variant"+i]:""}</span></div>

            <div className='VariationsSelector_variations_boxes_container'>
              {selectedVariants.length > 0 ?
                  variantData.values.map((option, index) => 
                  variantData.option_is_active === undefined || variantData.option_is_active[index] === true ?
                          <div className={`VariationsSelector_variations_box${selectedVariants[unit]["variant"+i]===option?"_selected":""}`}
                              onClick={(e) => getSelectedVariants(e, unit, i, null, option+"@"+index)}
                              value={option+"@"+index}
                              id={id}>
                              {/*THIS IS TO CHANGE THE "ORDER" JUST VISUALLY style={{order: Math.floor(Math.random() * variantData.values.length)}}> */}
                              {option}
                          </div>
                      : 
                          null
                  )
              : null}
            </div>
        </div>
        )
        :null}
      </div>
    )
  }
}

